import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M20.45,11s-.5-.37-1.17-.4H2.88l-.64,2.9h9.49c0-.6-.23-1.17-.81-1.63.57-.17,1.04-.6,1.34-1.17-.03.17-.03.3-.03.47,0,.87.37,1.47.91,1.9.1.1.6.4,1.54.4h6.61c.03-.23.07-.5.07-.73.07-.73-.37-1.33-.91-1.73M16.23,7.03c-.1,0-1.07.03-1.68.37-.64.33-1.44.97-1.88,2,0-.7-.23-1.43-.91-1.93-.54-.37-1.31-.47-1.74-.47h-.34l-6.04.03-.6,2.87h18.85l.6-2.9-6.27.03ZM1.5,17s6.31-.03,7.45-.03c.87,0,2.15-1.17,2.62-2.47l-.54,2.47h6.31c1.21,0,1.85-.23,1.95-.3.97-.47,1.61-1.33,1.91-2.47H2.1l-.6,2.8Z" />
  </>,
  "BS",
);

export default Icon;
